import * as React from "react";
import {CarouselItemProps} from "../CarouselItemProps";
import {DatesModel} from "../../../../modes";

export class DateCarouselItem extends React.PureComponent<CarouselItemProps<DatesModel>> {
    render() {
        const itemClass = "rj-carousel-item" + (this.props.isSelected ? " rj-carousel-item--active" : "");
        return (
            <div className={itemClass} onClick={this.props.handler} data-uat="carousel-item-date">
                <div className="rj-carousel-item__details">
                    <div className="rj-carousel-item__day">
                        {this.props.item.dayOfWeek}
                    </div>
                    <div className="rj-carousel-item__date">
                        {this.props.item.formattedDate}
                    </div>
                </div>
            </div>
        )
    }
}